import moment from "moment";

declare global {
    interface String {
        format(...args: any[]): string;
        toNumber(...args: any[]): number;
        toDate(format?: string): Date;
        reverse(): string;
    }
}

export function splitTrailingAsterisk(text: string): {text: string; hasAsterisk: boolean} {
    const trimmed = (text ?? '').trim();
    if (!trimmed) return {text: '', hasAsterisk: false};
    const hasAsterisk = /\*\s*$/.test(trimmed);
    return {
        text: trimmed.replace(/\s*\*\s*$/, ''),
        hasAsterisk,
    };
}

if (!String.prototype.format)
    String.prototype.format = function () {
        var args = arguments;
        return this.replace(/{(\d+)}/g, function (match, number) {
            return typeof args[number] != 'undefined' ?
                args[number] :
                match;
        });
    };
if (!String.prototype.toNumber)
    String.prototype.toNumber = function () {
        return Number(this);
    };

if (!String.prototype.toDate)
    String.prototype.toDate = function (format?: string) {
        format = format == null ? 'MM-DD-YYYY' : format;
        return moment(this.toString(), format).toDate()
    };

if (!String.prototype.reverse)
    String.prototype.reverse = function () {
        return this.split("").reverse().join("");
    }
export { }